<template>
  <div class="tw-flex tw-flex-col tw-justify-end tw-gap-4 tw-h-full tw-text-neutral-900 tw-text-sm">
    <div
      class="tw-text-center tw-flex tw-flex-col tw-items-center tw-text-neutral-900 tw-font-normal tw-text-xs tw-leading-4"
    >
      <img
        class="tw-max-w-40"
        src="/images/registration/stripe-cc-payments1.png"
        alt="Stripe Payments"
      >
      <span>All payments processed through <a
        href="https://stripe.com"
        target="_blank"
        class="tw-text-primary"
      >Stripe</a>.</span>
    </div>

    <div
      class="tw-text-center tw-flex tw-flex-col tw-items-center tw-text-neutral-900 tw-font-normal tw-text-xs tw-leading-4"
    >
      We use industry standard encryption to protect your personal information,<br>
      <span>
        by signing up you agree to our
        <a
          href="https://hikeseo.co/terms-conditions/"
          target="_blank"
          class="tw-text-primary"
        >
          Terms &amp; Conditions
        </a>.
      </span>
    </div>
  </div>
</template>
